import { render, staticRenderFns } from "./HoldEmployees.vue?vue&type=template&id=3185b8a9&scoped=true"
import script from "./HoldEmployees.vue?vue&type=script&lang=js"
export * from "./HoldEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185b8a9",
  null
  
)

export default component.exports